import { render, staticRenderFns } from "./UnitInfo.vue?vue&type=template&id=49d99fcc&scoped=true&"
import script from "./UnitInfo.vue?vue&type=script&lang=js&"
export * from "./UnitInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d99fcc",
  null
  
)

export default component.exports